import { useState } from "react";
import { Button, Table, Typography } from "antd";
import {
  downloadFile,
  downloadFileUnifiedById,
  fallbackString,
  formatDate,
  useIsUnifiedMode,
} from "@/shared/utils";
import { DocumentationExaminations } from "@entities/api/object/types.ts";
import "./object-info-opinion.scss";

const { Title } = Typography;

export const ObjectInfoOpinion = ({
  data,
}: {
  data: DocumentationExaminations[];
}) => {
  const [loadingFileIds, setLoadingFileIds] = useState<Record<string, boolean>>(
    {},
  );
  const setLoading = (fileId: string, loading: boolean) => {
    setLoadingFileIds((prev) => ({ ...prev, [fileId]: loading }));
  };

  const isUnifiedMode = useIsUnifiedMode();

  const columns = [
    {
      title: "№ заключения",
      dataIndex: "number",
      key: "number",
      render: (text: string, record: DocumentationExaminations) => {
        const fileId =
          record.examinationFile.file?.fileId ||
          record.examinationFile.signature?.fileId;

        if (fileId) {
          return (
            <Button
              type="link"
              loading={loadingFileIds[fileId]}
              onClick={() => {
                if (isUnifiedMode) {
                  downloadFileUnifiedById(fileId as string, setLoading);
                } else {
                  downloadFile(fileId as string, setLoading);
                }
              }}
            >
              {text}
            </Button>
          );
        }
        return <>{text}</>;
      },
    },
    {
      title: "Дата выдачи",
      dataIndex: "date",
      key: "date",
      render: (text: string | null) => (
        <>{text ? fallbackString(formatDate(text)) : "-"}</>
      ),
    },
    {
      title: "Наименование органа, выдавшего заключение",
      dataIndex: "issued",
      key: "issued",
      render: (text: string) => (
        <div className="object-info-opinion__issued-cell">{text}</div>
      ),
    },
  ];

  return (
    <div className="table-container">
      <Title level={5}>
        Сведения о положительном заключении экспертизы проектной документации
      </Title>
      <Table
        dataSource={data}
        columns={columns}
        pagination={false}
        className="custom-table"
        scroll={{ x: true }}
      />
    </div>
  );
};
